import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ordresApi } from "@services/api/ordres";

export interface DashboardStats {
  total: number;
  by_status: Record<string, number>;
  prepa: number;
  en_cours: number;
  termines: number;
  restitues: number;
  bloques: number;
  urgents: number;
  cached: boolean;
  stale: boolean;
  computed_at: string;
}

interface DashboardStatsStore {
  stats: DashboardStats | null;
  lastFetched: number | null;
  isRefreshing: boolean;

  fetchStats: (orgId: string, forceRefresh?: boolean) => Promise<void>;
  clearStats: () => void;
}

export const useDashboardStatsStore = create<DashboardStatsStore>()(
  persist(
    (set, get) => ({
      stats: null,
      lastFetched: null,
      isRefreshing: false,

      fetchStats: async (orgId: string, forceRefresh = false) => {
        if (forceRefresh) set({ isRefreshing: true });
        try {
          const stats = await ordresApi.dashboardStats(orgId, forceRefresh);
          set({ stats, lastFetched: Date.now(), isRefreshing: false });
          // If server returned stale cache, silently refresh in background
          if (stats.stale && !forceRefresh) {
            get().fetchStats(orgId, true);
          }
        } catch (error) {
          console.error("Error fetching dashboard stats:", error);
          set({ isRefreshing: false });
        }
      },

      clearStats: () => set({ stats: null, lastFetched: null }),
    }),
    {
      name: "dashboard-stats-cache",
      partialize: (state) => ({
        stats: state.stats,
        lastFetched: state.lastFetched,
      }),
    },
  ),
);
